import React from "react";
import logo from "./LogoG.jpg";
import { TextField } from "@mui/material";
import NumbersIcon from "@mui/icons-material/Numbers";

function QuoteHeader({ onOrderNumberChange, orderNumber }) {
  return (
    <div style={{ marginBottom: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "4px solid #ccc",
          marginBottom: "5%",
          marginTop: "-5%",
          paddingBottom: "0%",
          textTransform: "uppercase",
        }}
      >
        <div
          style={{
            fontFamily: "Lato, sans-serif",
            marginRight: "auto",
          }}
        >
          <div
            style={{
              fontSize: "40px",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            Quote
          </div>
          <div
            style={{
              fontSize: "20px",
              marginTop: "20%",
              fontWeight: 700,
            }}
          >
            <TextField
              required
              label="Order number"
              variant="outlined"
              value={orderNumber}
              onChange={(e) =>
                onOrderNumberChange(e.target.value.toUpperCase())
              }
              style={{ width: "100%", marginTop: "2%" }}
              InputProps={{
                disableUnderline: true,
                startAdornment: (
                  <NumbersIcon style={{ fontSize: 20 }}></NumbersIcon>
                ),
              }}
            />
          </div>
        </div>
        <img src={logo} alt="Company Logo" style={{ width: "350px" }} />
      </div>
    </div>
  );
}

export default QuoteHeader;
